'use client';

import { useSyncExternalStore } from 'react';

// Nothing to subscribe to: the store exists only for its server/client
// snapshot split, which is exactly "has hydration finished".
const subscribe = () => () => {};
const getClientSnapshot = () => true;
const getServerSnapshot = () => false;

/**
 * `false` for the server render AND the hydration render, `true` afterwards.
 *
 * Gate on it anything whose render output depends on the runtime — the clock,
 * the visitor's time zone, the browser's ICU data. Rendered straight away,
 * such output differs between the server HTML and the hydration render, React
 * treats the mismatch as a hydration failure and re-renders the whole page on
 * the client (BALLEE-HZ / BAL-1027). Gated, both renders agree and React
 * re-renders just the gated part once hydration is done.
 *
 * Unlike a `useEffect` + `setState` flag, it is `true` on the very first
 * render of a component mounted after hydration (client navigation), so
 * nothing flickers there.
 */
export function useIsHydrated(): boolean {
  return useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot);
}
